import {
	Button,
	Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { findComponentStep } from "../../utils/filter";

export const RegisterButton = () => {
	const { onChangeStep } = useContext(
		MultistepContext
	) as MultistepContextValues;

	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;
	const registerStep = findComponentStep(selectedFlow!, "Register");

	return (
		<>
			<Typography
				color="primary"
				sx={{
					fontFamily: "Noto Sans Gujarati",
					fontWeight: "regular",
					fontSize: 16,
				}}
			>
				<FormattedMessage
					id="login.signUpMessage"
					defaultMessage="¿No tienes una cuenta?"
				/>
			</Typography>
			<Button variant="text" onClick={() => onChangeStep(registerStep)}>
				<FormattedMessage id="login.signUp" defaultMessage="Registrarse" />
			</Button>
		</>
	);
};